import React from 'react';
import moment from 'moment';
import { Empty, Tabs, List, Tag } from 'antd';

import { getCurrencySign } from './invoices';
import { flexCenterRight } from './../theme';

const { TabPane } = Tabs;

const { groupBy, sumBy, orderBy } = require('lodash');

export const getUserStartInit = (yearData) => {
  return yearData.balanceInit/yearData.users.length;
}

export const showTabTitle = (pane, me) => {
  if (pane.userDetails.id === me.id) {
    return `${pane.userDetails.firstname} (me)`
  }
  return pane.userDetails.firstname;
}

export const showUserTabTitle = (user, me) => {
  if (user.id === me.id) {
    return `${user.firstname} (me)`
  }
  return user.firstname;
}

const renderUserCurrencyInvoices = (data, currency) => {
  return(
    <List
      style={{maxHeight: '400px',overflow: "auto"}}
      size="small"
      footer={<div style={flexCenterRight}>
        <div style={{marginRight: '8px'}}>
          Total(GBP):&nbsp;&nbsp;<Tag>£{sumBy(data, currency === 'GBP' ? 'paid' : 'convertPaid').toLocaleString()}</Tag>
        </div>
      </div>}
      bordered
      dataSource={orderBy(data, 'paymentReceivedDate', 'desc')}
      renderItem={item => <List.Item actions={[<Tag color="#B0BF1A" >£{currency === 'GBP' ? item.paid.toLocaleString() : item.convertPaid.toLocaleString()}</Tag>]}>
        <div>
          <span>{moment(item.paymentReceivedDate).format('YYYY-MM-DD')}</span>,&nbsp;
          <span><Tag>{item.client_invoice_name}</Tag></span>
          <span>{item.candidate_firstname} {item.candidate_lastname}</span>,&nbsp;
          <span>Paid: {getCurrencySign(item.actualCurrency)} {item.paid} (Received: {getCurrencySign(item.actualCurrency)} {item.amount}, Refund: {getCurrencySign(item.actualCurrency)} {item.actualRefund})</span>
        </div>
      </List.Item>}
    />
  )
}

export const renderUserInvoices = (data) => {
  if (data.length > 0) {
    return (
      <Tabs 
        animated={false}
      >
        {data.map((pane) => (
          <TabPane tab={pane.currency} key={pane.currency}>
            <div>{renderUserCurrencyInvoices(pane.data, pane.currency)}</div>
          </TabPane>
        ))}
      </Tabs>
    )
  }
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
}

const buildCurrencyInvoices = (invoicesArr) => {
  const currencyGroups = groupBy(invoicesArr, 'actualCurrency');
  return Object.keys(currencyGroups).map(e => {
    return {
      currency: e,
      data: currencyGroups[e],
    }
  });
}

export const getInvoices = (yearData, users, me) => {
  let meSales = 0;
  const groupUserInvoices = groupBy(yearData.invoices, 'user_id');

  /*** calculate total sales ***/
  const GBP = yearData.invoices.filter((i) => i.actualCurrency === 'GBP');
  const GBPTotal = sumBy(GBP, 'paid');

  const NonGBP = yearData.invoices.filter((i) => i.actualCurrency !== 'GBP');
  const NonGBPTotal = sumBy(NonGBP, 'convertPaid');
  /*****************************/

  /*** calculate me total sales ***/
  const meInvoices = groupUserInvoices[me.id];
  if (meInvoices) {
    const meGBP = meInvoices.filter((i) => i.actualCurrency === 'GBP');
    const meGBPTotal = sumBy(meGBP, 'paid');

    const meNonGBP = meInvoices.filter((i) => i.actualCurrency !== 'GBP');
    const meNonGBPTotal = sumBy(meNonGBP, 'convertPaid');

    meSales = meGBPTotal + meNonGBPTotal;
  }
  /********************************/

  /*** build all users invoices ***/
  const invoices = Object.keys(groupUserInvoices).map(e => {
    return {
      userId: e,
      userDetails: users.find((i) => i.id === e),
      data: buildCurrencyInvoices(groupUserInvoices[e]),
    }
  })
  /********************************/

  return {
    meSales,
    total: GBPTotal + NonGBPTotal,
    invoices,
  }
}

export const getCompanyExpenditures = (yearData) => {
  return {
    meExpenditures: (yearData.transaction.companyExpenditures.total/yearData.users.length).toFixed(2).toLocaleString(),
    total: yearData.transaction.companyExpenditures.total,
  };
}

export const getCompanyDividend = (yearData, user) => {
  return {
    total: yearData.companyDividend,
    meDividend: yearData.usersDividend[user.id],
    info: yearData.companyDividendInfo,
  }
}

export const getCompanyTax = (yearData, user) => {
  return {
    total: yearData.companyTax,
    meTax: yearData.usersTaxPaid[user.id]['taxPaid'],
    info: yearData.companyTaxInfo,
  }
}

export const getSalariesAndExpenditures = (yearData, user) => {
  const userData = yearData.transaction.userSalaryExpenditures[user.id];
  const totalSalary = sumBy(userData.salary, 'Credit');
  const totalExpenditure = sumBy(userData.expenditure, 'Credit');
  return totalSalary + totalExpenditure;
}

export const getUserEndBalance = (yearData, user) => {
  return yearData.usersEndBalance[user.id].balance;
}

export const getUserEndBalanceTotal = (yearData) => {
  const balanceArr = Object.keys(yearData.usersEndBalance).map(e => {
    return {
      balance: parseFloat(yearData.usersEndBalance[e]['balance']),
    }
  });
  return sumBy(balanceArr, 'balance');
}

export const getLastYearAccountLeftTotal = (yearData) => {
  const balanceArr = Object.keys(yearData.usersStartBalance).map(e => {
    return {
      balance: parseFloat(yearData.usersStartBalance[e]),
    }
  });
  return sumBy(balanceArr, 'balance');
}